export function saveState<T>(key: string, state: T) {
  const stateAsString = JSON.stringify(state);

  localStorage.setItem(key, stateAsString);
}

export function restoreState(key: string) {
  const stateAsString = localStorage.getItem(key);

  if (stateAsString !== undefined && stateAsString !== null)
    return JSON.parse(stateAsString);

  return null;
}

export function addCommunityToLocalAdmin(data?: any) {
  if (data) {
    const { id, name } = data;
    let state: any = localStorage.getItem('user-info');

    state = JSON.parse(state);

    const newState: any = {
      ...state,
      communities: [...state.communities, { id, name }],
    };

    localStorage.setItem('user-info', JSON.stringify(newState));
  }
}
